/* tslint:disable */
/* eslint-disable */
/* @relayHash 45e20ac37b8e1c73df6edb142a9dde79 */

import { ConcreteRequest } from "relay-runtime";
export type PortfolioItemsAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PortfolioType = "CART" | "HEART" | "%future added value";
export type ModifyPortfolioItemsInput = {
    action: PortfolioItemsAction;
    endPortfolioItemId?: string | null;
    itemsIds?: Array<string | null> | null;
    note?: string | null;
    portfolioItemsIds?: Array<string | null> | null;
    portfolioId?: string | null;
    portfolioType?: PortfolioType | null;
    startPortfolioItemId?: string | null;
    targetPortfolioItemId?: string | null;
    userId: string;
    clientMutationId?: string | null;
};
export type ModifyPortfolioItemsMutationVariables = {
    input: ModifyPortfolioItemsInput;
};
export type ModifyPortfolioItemsMutationResponse = {
    readonly modifyPortfolioItems: {
        readonly portfolio: {
            readonly id: string;
        } | null;
    } | null;
};
export type ModifyPortfolioItemsMutation = {
    readonly response: ModifyPortfolioItemsMutationResponse;
    readonly variables: ModifyPortfolioItemsMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ModifyPortfolioItemsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "modifyPortfolioItems",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ModifyPortfolioItemsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "portfolio",
        "storageKey": null,
        "args": null,
        "concreteType": "PortfolioV2",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ModifyPortfolioItemsMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ModifyPortfolioItemsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ModifyPortfolioItemsMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/ModifyPortfolioItemsMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '94aed0469fe8b3138bef1ac19d488d29';
export default node;
